module.exports = __webpack_public_path__ + "static/media/1POLICY42.41d3e3bf.jpg";